module.exports = __webpack_public_path__ + "fbf38af82b8a833832f0337683b810b0.png";